import React, { createContext, useState } from "react";

export const AudioContext = createContext({
  audioBlob: null,
  setAudioBlob: (blob: Blob | null) => {},
});

export const AudioProvider = ({ children }) => {
  const [audioBlob, setAudioBlob] = useState<Blob | null>(null);

  return (
    <AudioContext.Provider value={{ audioBlob, setAudioBlob }}>
      {children}
    </AudioContext.Provider>
  );
};
